<template>
    <a href="#" class="logo-wrapper">
        <!--<img width="90%" alt="Vue logo" src="../assets/logo.png">-->
        <svg width="60" height="60" xmlns="http://www.w3.org/2000/svg">
            <circle cx="30" cy="30" r="18" fill="none" stroke="#00FFFF" stroke-width="8" />
        </svg>
    </a>
</template>

<script>
    export default {
        name: "logo_c"
    }
</script>

<style scoped>
    .logo-wrapper{
        display: inline-block;
        width: 60px;
        height: 100%;
        overflow: hidden ;
        margin-right: 15px;
        float: right;
    }
</style>